// import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import { ThemeProvider, createTheme } from "@mui/material";
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Login from "./auth/Login";
import Admin from "./pages/admin/Admin";
import AdminRoomIn from "./pages/admin/v1/AdminRoomIn";
import { AdminBrainChaseRoomIn } from "./pages/brainChase/admin/AdminBrainChaseRoomIn";
import { AdminBrainChaseRoomManager } from "./pages/brainChase/admin/AdminBrainChaseRoomManager";
import { AdminBrainChaseScreen } from "./pages/brainChase/admin/AdminBrainChaseScreen";
import { BrainChaseGame } from "./pages/brainChase/player/BrainChaseGame";
import { BrainChaseRoomInWithId } from "./pages/brainChase/player/BrainChaseRoomIn";
import { Renda } from "./pages/duel/Renda";
import { AdminNazoClusterQuizGame } from "./pages/nazo-cluster-quiz/admin/AdminNazoClusterQuiz";
import { NazoClusterQuizPlayer } from "./pages/nazo-cluster-quiz/player/NazoClusterQuizPlayer";
import { NazoClusterQuizRoomInWithId } from "./pages/nazo-cluster-quiz/player/NazoClusterQuizRoomIn";
import { NazoClusterQuizScreen } from "./pages/nazo-cluster-quiz/screen/NazoClusterQuizScreen";
import Game from "./pages/player/Game";
import MyPage from "./pages/player/MyPage";
import RoomIn from "./pages/player/RoomIn";
import RoomInWithId from "./pages/player/RoomInWithId";
import Ranking from "./pages/Ranking";
import { SequenceScreen } from "./pages/sequence/SequenceScreen";
import Setter from "./pages/setter/Setter";
import SiritoriGame from "./pages/siritori/SiritoriGame";
import SiritoriRoomIn from "./pages/siritori/SiritoriRoomInWithId";
import Test from "./pages/Test";
import { Title } from "./pages/Title";
import { AdminSetEnter } from "./pages/v2arena/admin/AdminSetEnter";
import { AdminV2RoomIn } from "./pages/v2arena/admin/AdminV2RoomIn";
import V2RoomManager from "./pages/v2arena/admin/V2RoomManager";
import { V2Screen } from "./pages/v2arena/admin/V2Screen";
import { V2Game } from "./pages/v2arena/player/V2Game";
import { V2MyPage } from "./pages/v2arena/player/V2MyPage";
import V2Ranking from "./pages/v2arena/player/V2Ranking";
import { V2RoomIn } from "./pages/v2arena/player/V2RoomIn";
import { V2RoomInWithId } from "./pages/v2arena/player/V2RoomInWithId";
import { Statistics } from "./pages/v2arena/result/Statistics";
import Store from "./redux/store";
import { NazoClusterQuizGameWrapper } from "./pages/nazo-cluster-quiz/Wrapper";
import { BrainChaseGameReRun } from "./pages/brainChase/rerun/BrainChaseGameReRun";
import { BattleRoyaleRouter } from "./pages/battle-royale/BattleRoyaleRouter";
import AdminProjectList from "./pages/v3arena/admin/AdminProjectList";
import AdminProjectCreate from "./pages/v3arena/admin/AdminProjectCreate";
import AdminProjectDashboard from "./pages/v3arena/admin/AdminProjectDashboard";
import AdminRoomCreate from "./pages/v3arena/admin/AdminRoomCreate";
import AdminRoomManager from "./pages/v3arena/admin/AdminRoomManager";
import AdminRoomManagerWrapper from "./pages/v3arena/admin/AdminRoomManagerWrapper";
import V3Screen from "./pages/v3arena/screen/V3Screen";
import V3ScreenWrapper from "./pages/v3arena/screen/V3ScreenWrapper";
import V3PlayerLogin from "./pages/v3arena/player/V3PlayerLogin";
import V3MyPage from "./pages/v3arena/player/V3MyPage";
import V3EventCreate from "./pages/v3arena/player/V3EventCreate";
import V3RoomJoin from "./pages/v3arena/player/V3RoomJoin";
import V3Game from "./pages/v3arena/player/V3Game";
import V3GameWrapper from "./pages/v3arena/player/V3GameWrapper";
import V3RankingScreen from "./pages/v3arena/screen/V3RankingScreen";
import UploadTakeImages from "./pages/admin/UploadTakeImages";
import ViewTakeImages from "./pages/admin/ViewTakeImages";

const theme = createTheme({
  palette: {
    primary: {
      main: "#d32f2f",
    },
    secondary: {
      main: "#f50057",
    },
  },
});

const App: React.FC = () => {
  return (
    <Provider store={Store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Title />} />
            <Route path="/start" element={<Login />} />
            <Route path="/test" element={<Test />} />
            <Route path="/room" element={<RoomIn />} />
            <Route path="/room/:roomId" element={<RoomInWithId />} />
            <Route path="/room/:roomId/:hash/mypage" element={<MyPage />} />
            <Route path="/room/:roomId/:hash/game" element={<Game />} />
            <Route path="/room/:roomId/:hash/ranking" element={<Ranking />} />
            <Route path="/v2room" element={<V2RoomIn />} />
            <Route path="/v2room/:roomId" element={<V2RoomInWithId />} />
            <Route path="/v2room/:roomId/:hash/mypage" element={<V2MyPage />} />
            <Route path="/v2room/:roomId/:hash/game" element={<V2Game />} />
            <Route
              path="/v2room/:roomId/:hash/ranking"
              element={<V2Ranking />}
            />
            <Route
              path="/brainchase/:roomId"
              element={<BrainChaseRoomInWithId />}
            />
            <Route
              path="/brainchase/:roomId/rerun"
              element={<BrainChaseGameReRun />}
            />
            <Route
              path="/brainchase/:roomId/:hash/game"
              element={<BrainChaseGame />}
            />
            <Route path="/stats/:eventId/:roomId" element={<Statistics />} />
            <Route path="/archives/:eventId/:roomId" element={<Statistics />} />
            <Route
              path="/stats/:eventId/:roomId/:probId"
              element={<Statistics />}
            />
            <Route
              path="/archives/:eventId/:roomId/:probId"
              element={<Statistics />}
            />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/room" element={<AdminRoomIn />} />
            <Route path="/admin/set" element={<AdminSetEnter />} />
            <Route path="/admin/upload-take" element={<UploadTakeImages />} />
            <Route path="/admin/view-take" element={<ViewTakeImages />} />
            <Route path="/admin/v2room" element={<AdminV2RoomIn />} />
            <Route path="/admin/v2room/:roomId" element={<V2RoomManager />} />
            <Route path="/admin/v2room/:roomId/screen" element={<V2Screen />} />
            <Route
              path="/admin/brainchase"
              element={<AdminBrainChaseRoomIn />}
            />
            <Route
              path="/admin/brainchase/:roomId"
              element={<AdminBrainChaseRoomManager />}
            />
            <Route
              path="/admin/brainchase/:roomId/screen"
              element={<AdminBrainChaseScreen />}
            />
            <Route
              path="/admin/sequence/:roomId/screen"
              element={<SequenceScreen />}
            />
            <Route path="/race/:eventId" element={<Setter />} />
            <Route path="/word/:roomId" element={<SiritoriRoomIn />} />
            <Route path="/word/:roomId/:hash/game" element={<SiritoriGame />} />
            <Route path="/duel/:roomId/:hash/renda" element={<Renda />} />
            <Route
              path="/nazo-cluster-quiz/:roomId"
              element={
                <NazoClusterQuizGameWrapper>
                  <NazoClusterQuizRoomInWithId />
                </NazoClusterQuizGameWrapper>
              }
            />
            <Route
              path="/nazo-cluster-quiz/:roomId/:hash/game"
              element={
                <NazoClusterQuizGameWrapper>
                  <NazoClusterQuizPlayer />
                </NazoClusterQuizGameWrapper>
              }
            />
            <Route
              path="/admin/nazo-cluster-quiz/screen"
              element={
                <NazoClusterQuizGameWrapper>
                  <NazoClusterQuizScreen />
                </NazoClusterQuizGameWrapper>
              }
            />
            <Route
              path="/nazo-cluster-quiz/player/1st"
              element={
                <NazoClusterQuizGameWrapper>
                  <NazoClusterQuizPlayer />
                </NazoClusterQuizGameWrapper>
              }
            />
            <Route
              path="/nazo-cluster-quiz/player"
              element={
                <NazoClusterQuizGameWrapper>
                  <NazoClusterQuizPlayer />
                </NazoClusterQuizGameWrapper>
              }
            />
            <Route
              path="/admin/nazo-cluster-quiz/:roomId"
              element={
                <NazoClusterQuizGameWrapper>
                  <AdminNazoClusterQuizGame />
                </NazoClusterQuizGameWrapper>
              }
            />
            <Route
              path="/admin/nazo-cluster-quiz/:roomId/screen"
              element={
                <NazoClusterQuizGameWrapper>
                  <NazoClusterQuizScreen />
                </NazoClusterQuizGameWrapper>
              }
            />
            
            <Route path="/admin/v3/projects" element={<AdminProjectList />} />
            <Route path="/admin/v3/projects/new" element={<AdminProjectCreate />} />
            <Route path="/admin/v3/projects/:projectId" element={<AdminProjectDashboard />} />
            <Route path="/admin/v3/projects/:projectId/rooms/new" element={<AdminRoomCreate />} />
            <Route path="/admin/v3/room/:roomId" element={<AdminRoomManagerWrapper />} />
            <Route path="/admin/v3/projects/:projectId/rooms/:roomId" element={<AdminRoomManagerWrapper />} />
            <Route path="/admin/v3/projects/:projectId/rooms/:roomId/screen" element={<V3Screen />} />
            
            <Route path="/v3/:projectId/start" element={<V3PlayerLogin />} />
            <Route path="/v3/:projectId/mypage" element={<V3MyPage />} />
            <Route path="/v3/:projectId/events/new" element={<V3EventCreate />} />
            <Route path="/v3/:projectId/room/:roomId" element={<V3RoomJoin />} />
            <Route path="/v3/:projectId/room/:roomId/game" element={<V3GameWrapper />} />
            <Route path="/v3/:projectId/room/:roomId/screen" element={<V3ScreenWrapper />} />
            <Route path="/v3/:projectId/room/:roomId/ranking" element={<V3RankingScreen />} />
            
            <Route path="/battle-royale/*" element={<BattleRoyaleRouter />} />

            <Route path="/*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
